//@flow
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import inflightRequestsReducer, {
  STATE_KEY as INFLIGHT_REQUESTS,
} from './stores/inflightRequests'
import alertReducer, { STATE_KEY as ALERT } from './stores/alert'
import errorReducer, { STATE_KEY as ERROR } from './stores/error'
import pendingReducer, { STATE_KEY as PENDING } from './stores/pending'

import currentUserReducer, {
  STATE_KEY as CURRENT_USER,
} from './stores/currentUser'
import currentSettingsReducer, {
  STATE_KEY as CURRENT_SETTINGS,
} from './stores/currentSettings'
import currentPermissionsReducer, {
  STATE_KEY as CURRENT_PERMISSIONS,
} from './stores/currentPermissions'
import isCurrentUserFetchedReducer, {
  STATE_KEY as IS_CURRENT_USER_FETCHED,
} from './stores/isCurrentUserFetched'
import pollBuilderExpertOpinionCreateHelperReducer, {
  STATE_KEY as POLL_BUILDER_EXPERT_OPINION_CREATE_HELPER,
} from './stores/pollBuilderExpertOpinionCreateHelper'

import pollsStore from './stores/pollsStore'
import pollTypesStore from './stores/pollTypesStore'
import iconsStore from './stores/iconsStore'
import expertOpinionsStore from './stores/expertOpinionsStore'
import customersStore from './stores/customersStore'
import usersStore from './stores/usersStore'
import rolesStore from './stores/rolesStore'
import designsStore from './stores/designsStore'
import cursoredUrlsStore from './stores/cursoredUrlsStore'
import automationStore from './stores/automation'
import analytics from './stores/analytics'
import polls from './stores/polls'
import pollFilters from './stores/pollFilters'
import ui from './stores/ui'
import tags from './stores/tags'
import featureFlags from './stores/featureFlags'

import pollBuilderCheckedoutPollReducer, {
  STATE_KEY as POLL_BUILDER_CHECKEDOUT_POLL,
} from './stores/pollBuilderCheckedoutPoll'
import pollBuilderCheckedoutExpertOpinionsReducer, {
  STATE_KEY as POLL_BUILDER_CHECKEDOUT_EXPERT_OPINIONS,
} from './stores/pollBuilderCheckedoutExpertOpinions'
import pollBuilderSelectedExpertOpinionReducer, {
  STATE_KEY as POLL_BUILDER_SELECTED_EXPERT_OPINION,
} from './stores/pollBuilderSelectedExpertOpinion'
import pollBuilderIconPickerReducer, {
  STATE_KEY as POLL_BUILDER_ICON_PICKER,
} from './stores/pollBuilderIconPicker'
import { STATE_KEY as ROUTING } from './stores/routing'

import loginFormReducer, { STATE_KEY as LOGIN_FORM } from './stores/loginForm'
import type { FluxStandardAction } from './types'

import icons from './stores/icons'

import report from './stores/report/index'

import publisherReport from './stores/report/publishers'
import publisherRevenue from './stores/report/revenue'

//Constants
export const ROOT_CLEAR_STORE = 'ROOT_CLEAR_STORE'

//Actions
export const clearRootStore = () => ({
  type: ROOT_CLEAR_STORE,
})

//Reducers
const appReducer = combineReducers({
  [ROUTING]: routerReducer,

  // status
  [INFLIGHT_REQUESTS]: inflightRequestsReducer,
  [ALERT]: alertReducer,
  [ERROR]: errorReducer,
  [PENDING]: pendingReducer,

  // session
  [IS_CURRENT_USER_FETCHED]: isCurrentUserFetchedReducer,
  [CURRENT_USER]: currentUserReducer,
  [CURRENT_SETTINGS]: currentSettingsReducer,
  [CURRENT_PERMISSIONS]: currentPermissionsReducer,

  // stores
  pollsStore,
  pollTypesStore,
  iconsStore,
  expertOpinionsStore,
  customersStore,
  usersStore,
  rolesStore,
  designsStore,
  cursoredUrlsStore,
  automationStore,
  analytics,
  polls,
  pollFilters,
  ui,
  icons,
  tags,
  featureFlags,
  report,
  publisherReport,
  publisherRevenue,

  // component state

  // poll builder
  [POLL_BUILDER_CHECKEDOUT_POLL]: pollBuilderCheckedoutPollReducer,
  [POLL_BUILDER_CHECKEDOUT_EXPERT_OPINIONS]: pollBuilderCheckedoutExpertOpinionsReducer,
  [POLL_BUILDER_SELECTED_EXPERT_OPINION]: pollBuilderSelectedExpertOpinionReducer,
  [POLL_BUILDER_ICON_PICKER]: pollBuilderIconPickerReducer,
  [POLL_BUILDER_EXPERT_OPINION_CREATE_HELPER]: pollBuilderExpertOpinionCreateHelperReducer,

  // login form
  [LOGIN_FORM]: loginFormReducer,
})

export const rootReducer = (
  state: Object,
  action: FluxStandardAction,
  reducer: Function
) => {
  if (action.type === ROOT_CLEAR_STORE) {
    state = {}
  }

  return reducer(state, action)
}

export default (state: Object, action: FluxStandardAction) => {
  return rootReducer(state, action, appReducer)
}



// WEBPACK FOOTER //
// ./src/rootReducer.js